import { IState } from '../../../../store/types';
import { connect } from 'react-redux';
import { IPlaybackSettingsEvents, IPlaybackSettingsFields } from '../components/types';
import { PlaybackSettings } from '../components/PlaybackSettings';
import { IPlaybackSettingsHOCOwnProps } from './types';
import { getAutoSpeechRate, getPlayerRate, isHoverAutoPause } from '../../../../store/general/selectors';
import { SpeechVoiceUserSelector } from '../../../../effects/speechVoiceManager';
import { PlaybackSettingsEvents } from './events';

const mapStateToProps = (
  dispatch: any
) => {
  return (
    state: IState,
    {anchor}: IPlaybackSettingsHOCOwnProps
  ): IPlaybackSettingsFields => {
    const hoverAutoPause = isHoverAutoPause(state);
    const rate = getPlayerRate(state);

    return {
      anchor,
      hoverAutoPause,
      rate,
      autoSpeechRate: getAutoSpeechRate(state),
      canSelectVoice: !!SpeechVoiceUserSelector.getUserLangsForSelect().length,
    }
  };
}

const mapDispatchToProps = (
  dispatch: any,
  {onClose}: IPlaybackSettingsHOCOwnProps
): IPlaybackSettingsEvents => ({
    onClose,
    onHoverAutoPauseChange: () => dispatch(PlaybackSettingsEvents.onHoverAutoPauseChange()),
    onRateChange: rate => dispatch(PlaybackSettingsEvents.onRateChange(rate)),
    onAutoSpeechRateChange: rate => dispatch(PlaybackSettingsEvents.onAutoSpeechRateChange(rate)),
  }
);

export const PlaybackSettingsHOC = connect(
  mapStateToProps,
  mapDispatchToProps
)(PlaybackSettings);

PlaybackSettingsHOC.displayName = 'PlaybackSettingsHOC';
